import React from 'react';
import { DatabaseIcon, ServerIcon, ShieldIcon } from 'lucide-react';
import { systemsPortfolio } from '../../data/capabilities';
import { SectionHeading } from '../SectionHeading';
const icons = [DatabaseIcon, ServerIcon, ShieldIcon];
export function TechnicalMastery() {
  return <section id="systems" className="w-full bg-paper py-20 lg:py-28" data-id="element-146" data-mp="19g1fgcp03ehf">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-147" data-mp="19ie5ld4wwv5k">
        <SectionHeading title="Technical Mastery & Systems Portfolio" intro="Oversight of the platforms an enterprise actually runs on." data-id="element-148" data-mp="1dgv458a9oxbd" />

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-149" data-mp="1ngc7vk5yl14p">
          {systemsPortfolio.map((area, index) => {
          const Icon = icons[index] ?? DatabaseIcon;
          return <div key={area.title} className="flex h-full flex-col border border-line bg-white p-7" data-id="element-150" data-mp="3p7pc0703r4zp" data-mpi={index}>
                <Icon className="h-5 w-5 text-gold-600" aria-hidden="true" data-id="element-151" data-mp="3u726ndx7tgcu" />
                <h3 className="mt-6 font-display text-lg font-semibold leading-snug text-navy-900" data-id="element-152" data-mp="3k07j0hm08dtw">
                  {area.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-153" data-mp="3f6mhwgp473qh">
                  {area.detail}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}